"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var CompanyMembers_1 = require("./CompanyMembers");
var UserGroups_1 = require("./UserGroups");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Step3'), (0, recompose_1.withState)('step', 'setStep', 0), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'customer-wizard-step3' },
    React.createElement(sok_ui_1.Tabs, { activeIndex: props.step, onClick: props.setStep },
        React.createElement("div", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers')),
        React.createElement("div", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/userGroups')),
        React.createElement(CompanyMembers_1.default, { customerId: props.customerId, customerUuid: props.customerUuid }),
        React.createElement(UserGroups_1.default, { customerId: props.customerId })))); });
